import { useNavigate } from 'react-router-dom';
import { useManageInterface } from '../hooks/useManageInterface'
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

import { ManageConfiguration } from '../components/manageconfiguration/ManageConfiguration';
import { ManageFlowProcess } from '../components/manageFlowProcess/ManageFlowProcess';
import { MultiLanguageEditor } from '../../../components/others/MultiLanguageEditor';
import { ActionButtons } from '../../../components/others/ActionButtons';
import InterfaceForm from '../components/InterfaceForm';
import { safeParseJSON } from '../../../utils/jsonValidator';


export const LayoutInterface = () => {
    const navigate = useNavigate();
    const [
        values,
        errorInputs,
        workFlowLists,
        isEdit,
        handleInputChange,
        handleDirectInputChange,
        validateForm,
        save,
        t
    ] = useManageInterface();

    const handleSave = (e) => {
        e.preventDefault();
        const valid = validateForm();
        if (valid) {
            //SE DEJA ESTA FORMA PORQUE EL REPORTE TAMBIEN ES UN MENU, PENDIENTE VALIDAR SI SE DEBE DIFERENCIAR EN BASE DE DATOS
            if (values.type_action === 'CHART_REPORT')
                values.type_action = 'MENU';
            save(values);
            handleCancel();
        }
    };
    const handleCancel = () => navigate(-1);

    return (
        <Box sx={{ mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <InterfaceForm
                        values={values}
                        errorInputs={errorInputs}
                        workFlowLists={workFlowLists}
                        isEdit={isEdit}
                        handleInputChange={handleInputChange}
                        t={t}
                    />
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ManageConfiguration
                                data={safeParseJSON(values.configuration)}
                                typeAction={values.type_action}
                                isDisabled={!values?.type_action}
                                isEdit={isEdit}
                                addedConfiguration={handleDirectInputChange}
                                t={t}
                            />
                            <MultiLanguageEditor
                                value={values.configuration}
                                onChange={(e) => handleDirectInputChange("configuration", JSON.stringify(e))}
                                errorInputs={{}}
                                field={{
                                    id: "configuration",
                                    label: "Configuration:"
                                }}
                                htCtrl={"200"}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ManageFlowProcess
                                data={safeParseJSON(values.flow_process)}
                                typeAction={values.type_action}
                                isDisabled={!values?.type_action}
                                isEdit={isEdit}
                                addedFlowProcess={handleDirectInputChange}
                                t={t}
                            />

                            <MultiLanguageEditor
                                value={values.flow_process}
                                onChange={(e) => handleDirectInputChange("flow_process", JSON.stringify(e))}
                                errorInputs={{}}
                                field={{
                                    id: "flow_process",
                                    label: "Flow Process:"
                                }}
                                htCtrl={"200"}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ textAlign: 'right', mt: 4 }}>
                        <ActionButtons onSubmit={handleSave} onCancel={handleCancel} />
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};
